// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/chunks/" + ({"34":"210f95f9","748":"614dab02"}[chunkId] || chunkId) + "." + {"34":"7403cc36dd21e378","748":"d37cb9862afb1301","805":"cbec7868238bb94a"}[chunkId] + ".js";
};